import React from 'react';
import ImageComponent from '../../images';
import Spinner from "../../../component/spinner"

interface ButtonComponentProps {
  text?: string;
  onClick?: (e: any) => void;
  style?: React.CSSProperties;
  alt?: string,
  type?: "button" | "submit";
  btnClass?: string,
  disabled?: boolean,
  imagePath?: string; // New prop for the image source
  children?: any;
  isLoading?: boolean;
  title?: string;
  imageTooltipTitle?: string;
}

const ButtonComponent: React.FC<ButtonComponentProps> = ({
  text = "",
  onClick,
  style,
  imagePath,
  disabled = false,
  btnClass = "primary",
  children,
  type = "button",
  alt, // Include the imageSrc prop
  isLoading = false,
  imageTooltipTitle,
  ...arg
}) => {
  return (
    <button type={type} {...arg} className={disabled ? 'disabled-button' : btnClass} onClick={onClick} style={style} disabled={disabled}>
      {isLoading ? <Spinner spinnerClass={"loaderBtn"} /> : <>
        {imagePath && <ImageComponent path={imagePath} alt={alt} tooltipTitle={imageTooltipTitle} />} {text}
        {children}
      </>}
    </button>
  );
};

export default ButtonComponent;